import React, { createContext, useContext } from 'react'
import useChat from 'components/common/hooks/useChat'

const ChatContext = createContext(null)

export const ChatProvider = ({ children }) => {
  const chat = useChat()

  return <ChatContext.Provider value={{ chat }}>{children}</ChatContext.Provider>
}

export const useChatData = () => {
  const ctx = useContext(ChatContext)
  if (!ctx) throw new Error('useChatData must be used within a ChatProvider')
  return ctx
}
